import React from 'react';

import LoadingOverlay from 'components/LoadingOverlay';
import { Step } from 'components/SteppedModal';
import { TwitterPostModalSteps } from './types';

const useAuthenticationProgressStep = (): Step<TwitterPostModalSteps> => {
  return {
    id: 'authentication-in-progress',
    title: 'Authenticating with X',
    fluidFooterButtons: true,
    hideFooter: true,
    component: <LoadingOverlay small />,
  };
};

export default useAuthenticationProgressStep;
